import AppShell from "./AppShell";
import { getApp } from "@/lib/apps";

const Fryqnc = () => <AppShell app={getApp("fryqnc")} />;

export default Fryqnc;
